/* eslint-disable no-nested-ternary */
import React, {useEffect, useRef, useState} from 'react';

import {isEqual} from 'lodash';
import {batch, useDispatch, useSelector} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Get, Post} from '@/api/request';
import Diagram from '@/components/diagram/Diagram';
import * as APPDATA from '@/constants/pcConstAppData';
import * as COMMONFUNCTION from '@/libs/appHelper';
import convertCleaningStatusToDisplayString from '@/libs/cleaningWizardHelper';
import {consoleLog} from '@/libs/consoleHelper';
import {SecondToStringFormat, TimeRemaining} from '@/libs/dateHelper';

import {INITIAL_CUSTOM_OPERATION} from '../../../stores/reducers/setupStore';

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; // assign the value of ref to the argument
  }, [value]); // this code will run when the value of 'value' changes
  return ref.current; // in the end, return the current ref value.
}

function StatusRinse() {
  const dispatch = useDispatch();
  const setupStore = useSelector((state) => state.setupStore, isEqual);
  const {cleaningProperties, currentPCState, cleaningCustomOperation, prevActionWizard} = setupStore;

  const currentRunningSequence = cleaningCustomOperation.Operations.find((operation) => operation.Running);
  const currentRunningStatus =
    currentPCState === APPDATA.DEVICE_STATE.IDLE && cleaningCustomOperation.Status === APPDATA.DEVICE_STATE.IDLE
      ? APPDATA.DEVICE_STATE.IDLE
      : currentRunningSequence !== undefined
      ? currentRunningSequence.Sequence.replace('_', ' ').toUpperCase()
      : APPDATA.DEVICE_STATE.PREPARING;

  const [, setOperations] = useState(undefined);
  const [totalDuration, setTotalDuration] = useState('');
  const [timeRemaining, setTimeRemaining] = useState('');
  const [status, setStatus] = useState(APPDATA.DEVICE_STATE.IDLE);
  const [recomendedVolume] = useState(15);
  const [_isRunning, setIsRunning] = useState(false);
  const [currentState, setCurrentState] = useState(Diagram.STATUS.IDLE);
  const [triggerStopCleaning, setTriggerStopCleaning] = useState(false);
  const [isStopClicked, setIsStopClicked] = useState(false);

  const prevState = usePrevious(cleaningCustomOperation.Status);

  const textPropeties = [
    {
      label: 'Rinse Liquid Volume',
      content: `${recomendedVolume} mL`,
    },
    {
      label: 'Rinsing Duration',
      content: totalDuration,
    },
    {
      label: 'Time Remaining',
      content: timeRemaining,
    },
    {
      label: 'Status',
      content: convertCleaningStatusToDisplayString(status),
    },
  ];

  const resetCleaningProperties = {
    isCleaningWizardRunning: false,
    cleaningDuration: undefined,
    cleaningSolution: 15,
    valveChipType: 6,
    [APPDATA.KEY.MembraneCutOffSize]: undefined,
  };

  useEffect(() => {
    if (prevActionWizard) {
      dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
      window.location.href = APPDATA.CLEANING_WIZARD_ADDRESS;
    }
  }, [prevActionWizard]);

  useEffect(() => {
    setIsRunning(true);
    const currState = convertStatusCleainingWizardToDiagramStatus(status);
    setCurrentState(currState);
    dispatch(setupActions.updateActiveMenu(APPDATA.CLEANING_WIZARD));
    setupTopMenuProperties();

    return () => {
      setIsRunning(false);
      dispatch(modalActions.hidePopUp());
      // clearInterval(_cleaningWizardPooling);
    };
  }, []);

  useEffect(() => {
    setTotalDuration(SecondToStringFormat(cleaningProperties.cleaningDuration * 60));
    setTimeRemaining(
      TimeRemaining(cleaningProperties.cleaningDuration * 60, cleaningCustomOperation.TimeElapsed / 1000),
    );
    setOperations(cleaningCustomOperation.Operations);
    setStatus(
      cleaningCustomOperation.Status === APPDATA.DEVICE_STATE.DEPRESSURIZING
        ? cleaningCustomOperation.Status
        : currentRunningStatus,
    );
    setCurrentState(convertStatusCleainingWizardToDiagramStatus(status));
  }, [cleaningProperties, cleaningCustomOperation, currentRunningStatus, currentPCState]);

  useEffect(() => {
    if (triggerStopCleaning) {
      batch(() => {
        dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.CLEANING_WIZARD.STOPPED_RINSE_CYCLE,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        dispatch(loadingActions.showLoading(false));
        setupTopMenuProperties();
        dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
        window.location.href = APPDATA.CLEANING_WIZARD_ADDRESS;
      });
    } else if (
      !isStopClicked &&
      cleaningCustomOperation.Status === APPDATA.DEVICE_STATE.IDLE &&
      (prevState === APPDATA.DEVICE_STATE.RUNNING ||
        prevState === APPDATA.DEVICE_STATE.DEPRESSURIZING ||
        prevState === APPDATA.DEVICE_STATE.PREPARING)
    ) {
      batch(() => {
        dispatch(
          setupActions.setCleaningProperties({
            ...cleaningProperties,
            isCleaningWizardRunning: false,
          }),
        );

        // dispatch(setupActions.nextActionWizard(true));
        dispatch(loadingActions.showLoading(false));
        window.location.href = APPDATA.COMPLETE_RINSE_WIZARD_ADDRESS;
      });
    }
  }, [cleaningCustomOperation.Status, triggerStopCleaning, prevState]);

  useEffect(() => {
    if (cleaningCustomOperation.Message && !COMMONFUNCTION.IsEmpty(cleaningCustomOperation.Message)) {
      batch(() => {
        dispatch(setupActions.prevActionWizard(true));
        dispatch(
          setupActions.setCleaningProperties({
            ...resetCleaningProperties,
          }),
        );
        dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: cleaningCustomOperation.Message,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
      });
    }
  }, [cleaningCustomOperation]);

  const setupTopMenuProperties = () => {
    const topButtonProperties = {
      id: APPDATA.STOP,
      label: APPDATA.STOP,
      onClick: onClickBtn,
      disabled: false,
    };
    console.log('_isRunning :', _isRunning);
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: currentRunningStatus !== 'IDLE',
      onClick: cleaningWizardBackAction,
    };
    const titleMenuProperties = APPDATA.CLEANING_WIZARD;
    setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  const cleaningWizardBackAction = () => {
    consoleLog('cleaningWizardBackAction');
    backToHomePage();
  };

  const onClickBtn = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.STOP:
        Get(APPDATA.API.GET_STATUS_CLEANING_WIZARD, '', statusOfCleaningWizardStop);
        break;
      default:
        break;
    }
  };

  const statusOfCleaningWizardStop = (response) => {
    const status = response.data.Status;

    switch (status) {
      case APPDATA.DEVICE_STATE.IDLE:
        selectModeTopMenuProperties();
        break;
      case APPDATA.DEVICE_STATE.RUNNING:
      case APPDATA.DEVICE_STATE.PREPARING: {
        const popUpButton = [
          {
            id: APPDATA.CANCEL,
            isPrimaryButton: true,
            onClick: onClickStopButton,
            label: APPDATA.CANCEL,
            disabled: false,
          },
          {
            id: APPDATA.STOP,
            isPrimaryButton: false,
            onClick: onClickStopButton,
            label: APPDATA.STOP,
          },
        ];
        dispatch(
          modalActions.showPopUp({
            popUpTitle: APPDATA.STOP_RINSE_CYCLE,
            popUpText: APPDATA.MESSAGES.CLEANING_WIZARD.STOP_OR_CONTINUE_RINSE,
            popUpButton,
          }),
        );
        break;
      }
      default:
        break;
    }
  };

  const selectModeTopMenuProperties = () => {
    const topButtonProperties = undefined;
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: currentRunningStatus !== 'IDLE',
      onClick: cleaningWizardBackAction,
    };
    const titleMenuProperties = APPDATA.CLEANING_WIZARD;
    setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  const onClickStopButton = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.STOP: {
        ShowDepressurizingModalDialog();
        setIsStopClicked(true);
        const param = {};
        let variabel;
        Post(
          APPDATA.API.POST_STOP_CLEANIG_WIZARD,
          param,
          successStopCleaningWizard,
          variabel,
          failedStopCleaningWizard,
        );
        break;
      }
      case APPDATA.CANCEL:
        break;
      default:
        break;
    }
    dispatch(modalActions.hidePopUp());
  };

  const failedStopCleaningWizard = () => {
    setIsStopClicked(false);
  };

  const successStopCleaningWizard = () => {
    setTriggerStopCleaning(true);
  };

  const ShowDepressurizingModalDialog = () => {
    dispatch(
      loadingActions.updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.CYCLE_PROCESS.DEPRESSURIZING,
        // loadingButton1: {
        //   label: APPDATA.CLOSE,
        //   onClick: () => backToHomePage()
        // }
      }),
    );
  };

  const backToHomePage = () => {
    batch(() => {
      dispatch(loadingActions.showLoading(false));
      // need to reset the current store value for Custom Operation
      dispatch(setupActions.SetCleaningCustomOperation(INITIAL_CUSTOM_OPERATION));
      dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
      window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
    });
  };

  const setTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  const generateText = (textPropeties) => {
    let id = 0;
    const showText = textPropeties.map((text) => {
      id += 1;
      return (
        <div
          className="row center"
          key={id}
        >
          <div className="col-md-6 label-style">{text.label}</div>
          <div className="col-md-6 content-style">{text.content}</div>
        </div>
      );
    });
    return showText;
  };

  const convertStatusCleainingWizardToDiagramStatus = (status) => {
    switch (status) {
      case APPDATA.DEVICE_STATE.IDLE:
        return Diagram.STATUS.IDLE;
      case APPDATA.DEVICE_STATE.PREPARING:
      case APPDATA.DEVICE_STATE.DEPRESSURIZING:
        return Diagram.STATUS.PREPARING;
      case APPDATA.DEVICE_STATE.BUFFER_RECOVERY:
        return Diagram.STATUS.REVOCERING_BUFFFER;
      case APPDATA.DEVICE_STATE.REVERSE_DIAFILTRATE:
        return Diagram.STATUS.REVERSE_DIAFILTRATING;
      case APPDATA.DEVICE_STATE.PRIME:
        return Diagram.STATUS.PRIMING;
      case APPDATA.DEVICE_STATE.REVERSE_CONCENTRATE:
        return Diagram.STATUS.RECOVERING_AIR;
      case APPDATA.DEVICE_STATE.CONCENTRATE:
        return Diagram.STATUS.CONCENTRATING;
      case APPDATA.DEVICE_STATE.DIAFILTRATION:
      case APPDATA.DEVICE_STATE.DIAFILTRATE:
        return Diagram.STATUS.DIAFILTRRATING;
      default:
        return Diagram.STATUS.IDLE;
    }
  };

  return (
    <div className="status-cleaning-wizard rinse-cleaning-page">
      <div className="row row-content center cleaning-content">
        <div className="col-md-8 text-content  ">{generateText(textPropeties)}</div>
        <div className="col-md-4 diagram-content center ">
          <Diagram
            scaleSize="medium"
            isPaused={false}
            isRunning={cleaningProperties.isCleaningWizardRunning}
            currentState={currentState.replace(' ', '-')}
          />
        </div>
      </div>
    </div>
  );
}
export default StatusRinse;
